export const APP_NAME = 'Isempowe CMS'
